import type { Airflow } from '@aviata/platform-types';
import { isAdditionalProduct } from '../types/guards';
import type { AdditionalProduct, Product } from '../types/products';

const getProducts = (productsList: Product[]) => {
  return productsList.filter(isAdditionalProduct);
};

function isRoamingProduct(product: AdditionalProduct) {
  return product.type === 'products.roaming';
}

function isMedicalInsuranceProduct(product: AdditionalProduct) {
  return product.type === 'products.medical-insurance';
}

const getProductsPackage = (additionalProducts: AdditionalProduct[]) => {
  const packageProducts = additionalProducts.filter(
    product => product.data.$meta.package,
  );

  const packagePrice = packageProducts.reduce((price, product) => {
    return price + Number(product.total);
  }, 0);
  const packageTitle = packageProducts[0]?.data.$meta.package?.name || '';

  return {
    title: packageTitle,
    price: packagePrice,
  };
};

const getSeparateProducts = (additionalProducts: AdditionalProduct[]) => {
  return additionalProducts
    .filter(product => !product.data.$meta.package)
    .filter(product => !isRoamingProduct(product))
    .filter(product => !isMedicalInsuranceProduct(product))
    .map(product => ({
      title: product.data.$meta.title,
      price: Number(product.total),
      type: product.type,
    }));
};

export const getAdditionalProductsPrices = (
  productsList: Airflow.Order.Entity['products'],
) => {
  const additionalProducts = getProducts(productsList);

  const productsPackage = getProductsPackage(additionalProducts);
  const separateProducts = getSeparateProducts(additionalProducts);

  return {
    productsPackage,
    separateProducts,
  };
};
